import { render, staticRenderFns } from "./InstructionsList.vue?vue&type=template&id=08d7a722&scoped=true&"
import script from "./InstructionsList.vue?vue&type=script&lang=js&"
export * from "./InstructionsList.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsList.vue?vue&type=style&index=0&id=08d7a722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7a722",
  null
  
)

export default component.exports